module.exports = __webpack_public_path__ + "img/feat1Icon.a713b321.png";